import { Map, List } from 'immutable';

const ModuleStateModel = Map({
  confirm: Map({
    exitpoll: Map({
      questions: List(),
      isShowExitPoll: false,
    }),
  }),
});

export default ModuleStateModel;
